module.exports = __webpack_public_path__ + "static/media/new_logo.93abdab9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_logo.svg
// module id = 752
// module chunks = 0